import type { Delivery, IDeliveryLine, InventoryLevel, UntrackedMaterial } from '@interfaces/ILogistics';
import { useNow } from '@hooks/useNow';
import { lineStockAction, type IStockIndex } from '../stockActions';
import { zonedDay } from '../logistics.format';
import { LineStockActionCell } from './LineStockActionCell';

interface ILineStockActionProps {
  delivery: Delivery;
  line: IDeliveryLine;
  stockIndex: IStockIndex;
  tz: string;
  onSync: (level: InventoryLevel) => void;
  onAddStock: (material: UntrackedMaterial) => void;
  canEdit: boolean;
}

/** A drawer line's stock action, judged against a ticking site "today" — a
 *  drawer left open sees a due line turn into its Sync ask at midnight. */
export function LineStockAction({ delivery, line, stockIndex, tz, ...cell }: ILineStockActionProps) {
  const today = zonedDay(useNow(60_000).toISOString(), tz);
  return <LineStockActionCell action={lineStockAction(delivery, line, stockIndex, today)} {...cell} />;
}
